import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import '@/scss/style.scss';
import { Action } from '@/constants/ajax';
import { SET_GLOBAL_ERROR } from '@/constants/mutation-types';
import { DataObject } from '@/types';
import { UtilityHelper } from '@/helpers/UtilityHelper';
import { OandaHelper } from '@/helpers/OandaHelper';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueTelInput from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import { MaskInput } from 'vue-3-mask';
import { createHead } from '@vueuse/head';
import { initAmplitude } from './utils/AmplitudeAnalyticsEvents';
import { initOptimove } from './utils/Optimove';

const app = createApp(App);
const head = createHead();

app.config.globalProperties.$action = Action;
app.config.globalProperties.$globalErrorMessage = null;

app.use(router);
app.use(i18n);
app.use(store);
app.use(VueTelInput);
app.use(head);

app.component('MaskInput', MaskInput);

app.use(VueReCaptcha, {
    siteKey: (UtilityHelper.isOandaPath()
        ? process.env.VUE_APP_OANDA_RECAPTCHA_PUBLIC_KEY
        : process.env.VUE_APP_TMS_RECAPTCHA_PUBLIC_KEY) as string,
});

const htmlElement = document.querySelector('html');
if (htmlElement) {
    htmlElement.setAttribute('lang', i18n.global.locale.value);
}

const appScript = document.querySelector('[src="/app.js"]');
if (appScript) {
    const baseAppPath = appScript.getAttribute('src');
    const timestamp = Date.now();
    appScript.setAttribute('src', `${baseAppPath}?${timestamp}`);
}

store.dispatch('init', {});

if (UtilityHelper.isOandaPath()) {
    OandaHelper.updateFavicon();
}

UtilityHelper.addGtmContent();
UtilityHelper.initializeWebChat();

(window as any).setGlobalError = (message: string) => {
    store.commit(SET_GLOBAL_ERROR, message);
};

if ((window as any).Cypress) {
    (window as any).app = app;
    document.querySelector('#app')?.classList.add('cy-test');
}

initAmplitude(process.env.VUE_APP_AMPLITUDE_KEY as string);

initOptimove();

app.mount('#app');
declare global {
    interface Window {
        dataLayer: DataObject[];
        ConvrsChat?: any;
    }
}
